// node modules
import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import orderBy from 'lodash/orderBy';
import PropTypes from 'prop-types';

// app modules: components
import Heading from 'components/Heading';
import { UnorderedList, ListItem } from 'components/List';
import Link from 'components/Link';

// app modules: props
import NestedContentProps from 'components/NestedContent/NestedContentProps';

// app modules: services
import route from 'services/route';

// assets
import CssNestedContent from './NestedContent.scss';

class NestedContent extends Component {
  static propTypes = {
    content: NestedContentProps.content,
    title: PropTypes.string,
    indent: PropTypes.bool,
    isComponents: PropTypes.bool,
  };

  static defaultProps = {
    content: [],
    title: 'In this section',
    indent: false,
    isComponents: false,
  };

  static renderItems(items, indent = false) {
    return orderBy(items, 'index').map((item, index) => {
      const key = `nested-content-item-${item.id}`;
      let nbsps = null;

      if (indent) {
        nbsps = Array(index + 1)
          .fill('\u00A0')
          .join('');
      }

      return (
        <div key={key} className="nested-content__item">
          {nbsps}
          <ListItem>
            <Link to={route.content(item.id, item.title)} className="nested-content__link">
              {[item.recipe_number, ...item.title].join(' ')}
            </Link>
          </ListItem>
        </div>
      );
    });
  }

  static renderComponentsItems(items) {
    return orderBy(items, 'index').map((item, index) => {
      const key = `nested-content-item-${item.id}`;

      return (
        <div key={key} className="nested-content__item">
          <ListItem noBullet={!index}>
            {item.isLink ? (
              <Link to={route.content(item.id, item.title)} className="nested-content__link">
                {[item.recipe_number, ...item.title].join(' ')}
              </Link>
            ) : (
              <div className="nested-content__link__bold">
                {[item.recipe_number, ...item.title].join(' ')}
              </div>
            )}
          </ListItem>
        </div>
      );
    });
  }

  render() {
    const { content, title, indent, isComponents } = this.props;

    if (content?.length > 0) {
      return (
        <section className="margin-top-40 nested-content">
          <Heading>{title}</Heading>
          <UnorderedList
            className="list--dashed list--dashed-mine-shaft nested-content__list"
            spaceBetween="none"
            vertical
          >
            {isComponents
              ? NestedContent.renderComponentsItems(content)
              : NestedContent.renderItems(content, indent)}
          </UnorderedList>
        </section>
      );
    }

    return null;
  }
}

export default withStyles(CssNestedContent)(NestedContent);
